export const PALETTE = {
  green: '#006633',
  greenDark: '#00451f',
  greenAccent: '#00a65a',
  greenSoft: '#e6f3ec',
  greenBorder: '#c7e4d5',
  orange: '#f38725',
  orangeDark: '#c76a13',
  orangeSoft: '#fff1e0',
  orangeBorder: '#fcd9b0',
  text: '#0f172a',
  textMuted: '#64748b',
  subtle: '#94a3b8',
  neutral50: '#f8fafc',
  neutral100: '#f1f5f9',
  neutral200: '#e2e8f0',
  danger: '#dc2626',
  warning: '#f59e0b',
  blue: '#1d4ed8',
  blueSoft: '#e0ecff',
};

export const STATUS_COLORS: Record<string, string> = {
  Aberto: PALETTE.orange,
  Recebida: PALETTE.orange,
  Recebido: PALETTE.orange,
  'Em Análise': PALETTE.warning,
  'Em análise': PALETTE.warning,
  Resolvida: PALETTE.green,
  Resolvido: PALETTE.green,
  Finalizado: PALETTE.green,
  Arquivada: PALETTE.subtle,
  Arquivado: PALETTE.subtle,
};

export const PRIORITY_COLORS = [
  PALETTE.subtle,
  PALETTE.blue,
  PALETTE.warning,
  PALETTE.danger,
];

export const ACTIVITY_COLORS = [
  PALETTE.green,
  PALETTE.orange,
  PALETTE.greenAccent,
  PALETTE.orangeDark,
];

export const GENDER_COLORS = [PALETTE.green, PALETTE.orange, PALETTE.blue];

export const CHART_FONT = {
  fontFamily: 'Plus Jakarta Sans, sans-serif',
  fontSize: 12,
  fontWeight: 500,
  fill: PALETTE.textMuted,
};
